import type { DatePickerProps } from './DatePicker'
import DatePicker from './DatePicker'
export type { DatePickerProps }
export default DatePicker
